export default "__VITE_ASSET__394bf692__"